import { render } from "./TabAzienda.vue?vue&type=template&id=b3bc6174&scoped=true"
import script from "./TabAzienda.vue?vue&type=script&lang=js"
export * from "./TabAzienda.vue?vue&type=script&lang=js"

import "./TabAzienda.vue?vue&type=style&index=0&id=b3bc6174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3bc6174"]])

export default __exports__